import { useTabsComponents } from '@/next/utils/useTabsComponents';
import { Layer } from '@/stores/viewer';
import { cn } from '@/utils/classname';
import { IfcElementNode } from '@skand/viewer-component-v2';
import { IFCTab } from './IFCTab';
import { LayeringTab } from './LayeringTab';

export interface IFCSettingsMenuProps {
  layer: Layer;
  setSelectedIfcElement: (node: IfcElementNode | null) => void;
  selectedIfcElement: IfcElementNode | null;
}

export const IFCSettingsMenu = ({
  layer,
  selectedIfcElement,
  setSelectedIfcElement,
}: IFCSettingsMenuProps) => {
  const { Tabs, TabsList, TabsTrigger, TabsContent } = useTabsComponents();

  return (
    <div className={cn('w-full flex flex-col')}>
      <Tabs defaultValue="layering">
        <TabsList>
          <TabsTrigger value="layering">Layering</TabsTrigger>
          <TabsTrigger value="ifc">IFC</TabsTrigger>
        </TabsList>

        <TabsContent value="layering">
          <LayeringTab layer={layer} />
        </TabsContent>
        <TabsContent value="ifc">
          <IFCTab
            layer={layer}
            selectedIfcElement={selectedIfcElement}
            setSelectedIfcElement={setSelectedIfcElement}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};
